__turbopack_context__.v({
  "trailing_items": "TrailingItems-module-scss-module__HGpMvq__trailing_items",
  "trailing_items__cta_group": "TrailingItems-module-scss-module__HGpMvq__trailing_items__cta_group",
  "trailing_items__user_avatar": "TrailingItems-module-scss-module__HGpMvq__trailing_items__user_avatar",
});
